import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';
import { ChildContext } from '../components/Layout/ParentLayout';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
  .pd * { box-sizing:border-box; }
  .pd { font-family:'Sora',sans-serif; color:#1a1d2e; animation:pdFade .4s ease both; }
  @keyframes pdFade { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
  .pd-welcome { background:linear-gradient(135deg,#f97316,#ef4444); border-radius:16px; padding:1.4rem 1.6rem; color:white; margin-bottom:1.4rem; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:12px; }
  .pd-welcome-title { font-size:1.3rem; font-weight:700; }
  .pd-welcome-sub   { font-size:.78rem; opacity:.85; margin-top:3px; }
  .pd-child-info    { text-align:right; font-size:.76rem; opacity:.8; }
  .pd-stat-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:.9rem; margin-bottom:1.4rem; }
  .pd-stat { background:white; border-radius:14px; padding:1rem 1.1rem; border:1px solid #e8ebf4; }
  .s-icon { width:32px; height:32px; border-radius:9px; display:flex; align-items:center; justify-content:center; margin-bottom:.6rem; }
  .s-icon svg { width:15px; height:15px; stroke-width:1.8; }
  .s-icon.green{background:#ecfdf5;color:#10c98e} .s-icon.red{background:#fef2f2;color:#ef4444}
  .s-icon.amber{background:#fffbeb;color:#f59e0b} .s-icon.blue{background:#eef2ff;color:#3b6ef8}
  .s-icon.orange{background:#fff7ed;color:#f97316}
  .s-label { font-size:.67rem; font-weight:600; color:#9094a8; text-transform:uppercase; letter-spacing:.06em; }
  .s-value { font-size:1.4rem; font-weight:700; color:#0f1123; font-family:'JetBrains Mono',monospace; }
  .s-sub   { font-size:.68rem; color:#b0b5cc; margin-top:3px; }
  .fee-alert { background:#fef2f2; border:1px solid #fecaca; border-radius:12px; padding:12px 16px; margin-bottom:1.4rem; display:flex; align-items:center; justify-content:space-between; gap:12px; }
  .fee-alert-left { display:flex; align-items:center; gap:10px; }
  .fee-alert svg { width:20px; height:20px; color:#ef4444; flex-shrink:0; }
  .fee-alert-title { font-size:.84rem; font-weight:700; color:#ef4444; }
  .fee-alert-sub   { font-size:.72rem; color:#9094a8; margin-top:2px; }
  .fee-alert-amount { font-size:1rem; font-weight:700; color:#ef4444; font-family:'JetBrains Mono',monospace; white-space:nowrap; }
  .pd-grid { display:grid; grid-template-columns:1fr 1fr; gap:1rem; }
  .pd-card { background:white; border-radius:16px; border:1px solid #e8ebf4; overflow:hidden; }
  .pd-card-hdr { display:flex; align-items:center; justify-content:space-between; padding:14px 18px; border-bottom:1px solid #f0f2f8; }
  .pd-card-title { font-size:.86rem; font-weight:600; color:#1a1d2e; }
  .pd-card-link { font-size:.74rem; font-weight:600; color:#f97316; cursor:pointer; text-decoration:none; }
  .pd-card-link:hover { text-decoration:underline; }
  .result-row { display:flex; align-items:center; gap:10px; padding:10px 18px; border-bottom:1px solid #f3f5fb; }
  .result-row:last-child { border-bottom:none; }
  .result-subj { font-size:.82rem; font-weight:600; color:#0f1123; flex:1; }
  .result-type { font-size:.68rem; padding:2px 8px; border-radius:99px; background:#f0f2f7; color:#6b7194; font-weight:600; white-space:nowrap; }
  .result-bar  { width:80px; height:5px; border-radius:99px; background:#f0f2f8; overflow:hidden; flex-shrink:0; }
  .result-fill { height:100%; border-radius:99px; }
  .result-score{ font-size:.76rem; font-weight:700; font-family:'JetBrains Mono',monospace; min-width:44px; text-align:right; }
  .exam-row { display:flex; align-items:center; gap:10px; padding:10px 18px; border-bottom:1px solid #f3f5fb; }
  .exam-row:last-child { border-bottom:none; }
  .exam-date { font-size:.68rem; font-family:'JetBrains Mono',monospace; color:#9094a8; min-width:52px; }
  .exam-subj { font-size:.82rem; font-weight:600; color:#0f1123; flex:1; }
  .exam-type { font-size:.68rem; padding:2px 8px; border-radius:99px; background:#eef2ff; color:#3b6ef8; font-weight:600; }
  .pd-empty { text-align:center; padding:2rem; color:#9094a8; font-size:.82rem; }
  .pd-loading { display:flex; align-items:center; justify-content:center; height:160px; gap:10px; color:#9094a8; }
  .spinner { width:18px; height:18px; border:2px solid #e4e7f0; border-top-color:#f97316; border-radius:50%; animation:spin .7s linear infinite; }
  @keyframes spin { to{transform:rotate(360deg)} }
  .no-child { background:white; border-radius:16px; border:1px solid #e8ebf4; padding:3rem; text-align:center; color:#9094a8; font-size:.88rem; }
  @media(max-width:768px) { .pd-stat-grid{grid-template-columns:repeat(2,1fr);} .pd-grid{grid-template-columns:1fr;} .pd-welcome-title{font-size:1.1rem;} }
`;

const pctColor = (p) => p>=80?'#10c98e':p>=60?'#f59e0b':'#ef4444';
const fmtDate  = (d) => d ? new Date(d).toLocaleDateString('en-GB',{day:'2-digit',month:'short'}) : '—';
const fmt      = (n) => `Rs. ${Number(n||0).toLocaleString('en-PK')}`;

export default function ParentDashboard() {
  const { activeChild } = useContext(ChildContext);
  const navigate = useNavigate();
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!activeChild) return;
    setLoading(true);
    api.get(`/parent/dashboard/${activeChild._id}`)
      .then(r => setData(r.data))
      .catch(() => toast.error('Failed to load dashboard'))
      .finally(() => setLoading(false));
  }, [activeChild?._id]);

  if (!activeChild) return (
    <div className="pd"><style>{css}</style>
      <div className="no-child">
        <div style={{fontSize:'2.5rem',marginBottom:10}}>👨‍👩‍👧</div>
        <div style={{fontWeight:700,fontSize:'1rem',color:'#0f1123',marginBottom:6}}>No children linked</div>
        <div>Please contact school admin to link your children to this account.</div>
      </div>
    </div>
  );

  const att = data?.attendance;
  const attPct = att?.totalDays>0 ? Math.round(((att.present+att.late)/att.totalDays)*100) : 0;

  return (
    <div className="pd"><style>{css}</style>
      {/* Welcome */}
      <div className="pd-welcome">
        <div>
          <div className="pd-welcome-title">Welcome 👋</div>
          <div className="pd-welcome-sub">Here's an overview of {activeChild.name}'s progress</div>
        </div>
        <div className="pd-child-info">
          <div style={{fontWeight:700}}>{activeChild.name}</div>
          <div>{activeChild.class} — Section {activeChild.section} · Roll {activeChild.rollNo}</div>
        </div>
      </div>

      {/* Fee alert */}
      {data?.feeStatus?.overdueCount>0 && (
        <div className="fee-alert">
          <div className="fee-alert-left">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></svg>
            <div>
              <div className="fee-alert-title">Fee Overdue!</div>
              <div className="fee-alert-sub">{data.feeStatus.overdueCount} overdue payment{data.feeStatus.overdueCount!==1?'s':''}</div>
            </div>
          </div>
          <div className="fee-alert-amount">{fmt(data.feeStatus.overdueAmount)}</div>
        </div>
      )}

      {loading ? <div className="pd-loading"><div className="spinner"/>Loading…</div> : !data ? null : (
        <>
          {/* Stats */}
          <div className="pd-stat-grid">
            <div className="pd-stat">
              <div className="s-icon green"><svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg></div>
              <div className="s-label">Attendance</div>
              <div className="s-value" style={{color:pctColor(attPct)}}>{attPct}%</div>
              <div className="s-sub">{att?.present||0} present · {att?.absent||0} absent</div>
            </div>
            <div className="pd-stat">
              <div className="s-icon blue"><svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/></svg></div>
              <div className="s-label">Recent Results</div>
              <div className="s-value">{data.recentResults?.length||0}</div>
              <div className="s-sub">assessments marked</div>
            </div>
            <div className="pd-stat">
              <div className="s-icon amber"><svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg></div>
              <div className="s-label">Quizzes</div>
              <div className="s-value">{data.quizSummary?.attempted||0}<span style={{fontSize:'.9rem',color:'#9094a8'}}>/{data.quizSummary?.total||0}</span></div>
              <div className="s-sub">attempted</div>
            </div>
            <div className="pd-stat">
              <div className="s-icon orange"><svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg></div>
              <div className="s-label">Upcoming Exams</div>
              <div className="s-value">{data.upcomingExams?.length||0}</div>
              <div className="s-sub">scheduled</div>
            </div>
          </div>

          {/* Recent results + upcoming exams */}
          <div className="pd-grid">
            <div className="pd-card">
              <div className="pd-card-hdr">
                <div className="pd-card-title">Recent Results</div>
                <span className="pd-card-link" onClick={()=>navigate('/parent/results')}>View all</span>
              </div>
              {!data.recentResults?.length ? (
                <div className="pd-empty">No results yet.</div>
              ) : data.recentResults.map((r,i) => {
                const pct = r.maxMarks>0 ? Math.round((r.marksObtained/r.maxMarks)*100) : 0;
                return (
                  <div key={i} className="result-row">
                    <div className="result-subj">{r.subject}</div>
                    <span className="result-type">{r.assessmentType}</span>
                    <div className="result-bar"><div className="result-fill" style={{width:`${pct}%`,background:pctColor(pct)}}/></div>
                    <div className="result-score" style={{color:pctColor(pct)}}>{r.marksObtained}/{r.maxMarks}</div>
                  </div>
                );
              })}
            </div>

            <div className="pd-card">
              <div className="pd-card-hdr">
                <div className="pd-card-title">Upcoming Exams</div>
                <span className="pd-card-link" onClick={()=>navigate('/parent/datesheets')}>View all</span>
              </div>
              {!data.upcomingExams?.length ? (
                <div className="pd-empty">No upcoming exams.</div>
              ) : data.upcomingExams.map((e,i) => (
                <div key={i} className="exam-row">
                  <div className="exam-date">{fmtDate(e.date)}</div>
                  <div className="exam-subj">{e.subject}</div>
                  <span className="exam-type">{e.assessmentType?.name||'—'}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}